import type { IconData } from '@stacksjs/iconify-core'

export const healthHealth: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M12 0H4v4H0v8h4v4h8v-4h4V4h-4z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default healthHealth
